import React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import EditNoteOutlined from '@mui/icons-material/NotesOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';

import { useTranslation } from 'react-i18next';

import { ButtonRow, FormTextarea, useTrackedFormik } from '@omnigenbiodata/ui';

import PortalLayout from '../../../../../../layout/Portal';
import ROUTES from '../../../../../../core/constants/routes.constant';
import { useAppSelector, useAppDispatch } from '../../../../../../store';
import { withdrawalForward } from '../../../../../../store/participant';
import { withdrawalValuesSelector } from '../../../../../../store/participant/selectors';
import { chartColours } from '../../../../../../core/constants/colours.constants';
import PageContainer from '../../../../../../components/content/PageContainer';
import PageSection from '../../../../../../components/content/PageSection';

function WithdrawalReasonScene() {
  const dispatch = useAppDispatch();
  const values = useAppSelector(withdrawalValuesSelector);
  const navigate = useNavigate();
  const { t } = useTranslation('portal');

  const formik = useTrackedFormik(
    {
      initialValues: {
        withdrawalReason: values?.withdrawalReason ? values.withdrawalReason.toString() : '',
      },
      onSubmit: (values) => {
        dispatch(withdrawalForward(values));
        navigate(ROUTES.portalWithdrawalConfirm1);
      },
    },
    'withdrawal-reason',
  );

  return (
    <PortalLayout>
      <PageContainer
        title={t('withdrawal3.title')}
        icon={
          <Box
            sx={{
              width: 54,
              height: 54,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: `${chartColours[5]}26`,
              color: chartColours[5],
              flexShrink: 0,
              border: 1,
              borderColor: `${chartColours[5]}55`,
            }}
          >
            <WarningAmberOutlined sx={{ fontSize: 34 }} />
          </Box>
        }
      >
        <form onSubmit={formik.handleSubmit}>
          <PageSection
            title={t('withdrawal3.subtitle')}
            colour={chartColours[0]}
            icon={<EditNoteOutlined sx={{ fontSize: 30 }} />}
          >
            <Typography
              variant="body1"
              component="p"
              color="text.secondary"
              sx={{
                mb: 2.5,
                maxWidth: 760,
                lineHeight: 1.6,
              }}
            >
              {t('withdrawal3.para1')}
            </Typography>

            <Box
              sx={{
                '& textarea': {
                  borderRadius: 2,
                },
                '& label': {
                  fontWeight: 800,
                },
              }}
            >
              <FormTextarea
                label={t('withdrawal3.subtitle')}
                name="withdrawalReason"
                error={formik.errors.withdrawalReason}
                value={formik.values.withdrawalReason}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                touched={formik.touched.withdrawalReason}
              />
            </Box>
          </PageSection>
          <Box
            sx={{
              '& button': {
                borderRadius: 999,
                fontWeight: 900,
                textTransform: 'none',
              },
            }}
          >
            <ButtonRow
              backLabel={t('withdrawal3.back')}
              forwardLabel={t('withdrawal3.button')}
              forwardColor="error"
              buttonSize="large"
            />
          </Box>
        </form>
      </PageContainer>
    </PortalLayout>
  );
}

export default WithdrawalReasonScene;
